import { getCrmColors } from "../../theme/crmColors";
import React from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		background: theme.ticketDark ? getCrmColors(theme, "dark").surface : (theme.mode === "light" ? "#ffffff" : "#2f2f2f"),
		color: theme.ticketDark ? "#FFFFFF" : (theme.mode === "light" ? "#172033" : "#f8fafc"),
		flex: "none",
		borderBottom: theme.ticketDark ? `1px solid ${getCrmColors(theme, "dark").border}` : (theme.mode === "light" ? "1px solid #e6edf6" : "1px solid rgba(255,255,255,0.08)"),
		boxShadow: theme.mode === "light" ? "0 1px 0 rgba(15, 23, 42, 0.03)" : "0 1px 0 rgba(255,255,255,0.02)",
		height: "68px",
		alignItems: "center",
		"& .MuiButton-root": {
			minWidth: 42,
			height: 42,
			marginLeft: theme.spacing(1),
			borderRadius: 8,
			color: theme.ticketDark ? "#FFFFFF" : theme.palette.primary.main,
			border: 0,
			backgroundColor: "transparent",
		},
		"& .MuiButton-root:hover": {
			backgroundColor: theme.ticketDark ? getCrmColors(theme, "dark").hover : (theme.mode === "light" ? "#edf6ff" : "#3a3a3a"),
		},
		"& #TicketHeader": {
			flex: 1,
			minWidth: 0,
		},
		[theme.breakpoints.down("sm")]: {
			flexWrap: "wrap",
			height: 'max-content',
			...(theme.ticketDark ? {
				display: "grid",
				gridTemplateColumns: "50px minmax(0, 1fr) 48px",
			} : {}),
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button color="primary" onClick={handleBack}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
